import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ number, label, dark = true }) => (
  <Reveal className="mb-6 flex items-center gap-4" y={16}>
    <span className={`font-mono text-xs tracking-[0.3em] ${dark ? "text-mint" : "text-forest"}`}>
      {number}
    </span>
    <span className={`h-px w-10 ${dark ? "bg-moss" : "bg-forest/40"}`} />
    <span
      className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-fog" : "text-ink/60"}`}
    >
      {label}
    </span>
  </Reveal>
);

export const SectionHeading = ({ children, dark = true, className = "" }) => (
  <Reveal delay={0.08}>
    <h2
      className={`font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight leading-[1.12] ${
        dark ? "text-bone" : "text-ink"
      } ${className}`}
    >
      {children}
    </h2>
  </Reveal>
);

export { EASE };
